import { BoxTabs } from "../../../components/AntdTab/AntdTab";
import HistoryEvents from "./HistoryEvents/HistoryEvents";
import UpcomingEvents from "./UpcomingEvents/UpcomingEvents";

const GuestEvents = () => {
  const items = [
    {
      key: "1",
      label: "Upcoming",
      headerTitle: "Events",
      children: <UpcomingEvents />,
    },
    {
      key: "2",
      label: "History",
      headerTitle: "Events",
      children: <HistoryEvents />,
    },
  ];

  return <BoxTabs items={items} changeHeaderOnTab={true} destroyOnBlur />;
};

export default GuestEvents;
